import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const Tracking = () => {
  const navigate = useNavigate();
  const { activity_assignment_id } = useParams();
  const user = useSelector((state) => state.auth);

  useEffect(() => {
    // user.type === "customer"
    let user = localStorage.getItem("user") || "{}";
    user = JSON.parse(user);
    if (user.type === "customer" && user.token) {
      navigate(`/todo/performance/${activity_assignment_id}`);
    } else {
      navigate(`/login`, { state: { type: "customer", redirectTo: `/tracking/${activity_assignment_id}`} });
    }
  }, [activity_assignment_id, navigate, user]);

  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <span className="ml-2">
        <svg
          className="animate-spin w-20 h-20 fill-current shrink-0"
          viewBox="0 0 16 16"
        >
          <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
        </svg>
      </span>
    </div>
  );
};

export default Tracking;
